import React from "react";
import "../../css/timeline.css";

export interface IWorkItem {
  imageSrc?: string;
  link?: string;
  company: string;
  roles: IRole[];
}

export interface IRole {
  title: string;
  date: string;
  description?: string;
  listItems?: string[];
}

const WorkHistorySection = ({ content }: { content: IWorkItem[] }) => {
  return (
    <div className="">
      {content.map((item: IWorkItem, index: number) => {
        return (
          <div className="mt-3">
            <div className="d-flex align-items-center">
              {item.imageSrc && item.link ? (
                <a href={item.link} target="_blank" rel="noreferrer">
                  <img
                    className="timeline-img img-link"
                    src={item.imageSrc}
                    alt="logo"
                  />
                </a>
              ) : (
                <img className="timeline-img" src={item.imageSrc} alt="logo" />
              )}
              <div className="w-100">
                <div className="timeline-title">
                  {item.link ? (
                    <a href={item.link} target="_blank" rel="noreferrer">
                      {item.company}
                    </a>
                  ) : (
                    item.company
                  )}
                </div>
              </div>
            </div>

            {item.roles.map((item: IRole, index: number) => {
              return (
                <div>
                  <div className="mt-2 d-flex flex-wrap justify-content-between w-100">
                    <div className="timeline-subtitle">{item.title}</div>
                    <div className="timeline-date">{item.date}</div>
                  </div>
                  <div className="timeline-description mt-2">{item.description}</div>
                  <div className="timeline-list mt-2">
                    <ul>
                      {item.listItems &&
                        item.listItems.map((listItem: string, listIndex: number) => {
                          return (
                            <li
                              className="mt-2"
                              key={"item-" + index + "-listItem-" + listIndex}
                            >
                              {listItem}
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                </div>
              );
            })}

          </div>
        );
      })}
    </div>
  );
};

export default WorkHistorySection;
